import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetCameraTrapsQuery, GetCameraTrapsResponse } from "./type";

async function getCameraTraps(
  query: GetCameraTrapsQuery,
): Promise<GetCameraTrapsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.devices.cameraTraps.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetCameraTrapsResponse>(url);

  return response.data;
}

export function useGetCameraTraps(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-camera-traps`, JSON.stringify(query ?? {})],
    () => getCameraTraps(query ?? {}),
    mergedOptions,
  );
}
